module.exports = __webpack_public_path__ + "img/south-caicos.86e6221a.jpg";